/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import Popup from "react-popup";
import { trackPromise } from "react-promise-tracker";
import TransferInterbancaService from "../../../../services/transferencias/TransferInterbancaService";
import TransferXpressService from "../../../../services/transferencias/TransferXpressService";
import CuentaExternaService from "../../../../services/transferencias/CuentaExternaService";
import $ from "jquery";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faClose, faSave} from "@fortawesome/free-solid-svg-icons";

//PopupAgreagrCuentaCabal
export default class PopupAgreagrCuentaCabal extends Component {
  constructor(props) {
    super(props);
    this.guardar = this.guardar.bind(this);
    this.validate = this.validate.bind(this);
    this.initData();
    this.state = {
      ...this.getInitialState(),
      errors: {},
    };
  }

  initData() {
    this.state = this.getInitialState();
    this.getTipoEntidad();
    this.getTiposDocumentos();
    this.clearState();
  }

  getInitialState = () => ({
    tipoEntidadNew: "",
    tipoEntidadList: [],
    entidadNew: "",
    entidadList: [],
    nroCuentaNew: "",
    nombreApellidoNew: "",
    tipoDocNew: "",
    tipoDocList: [],
    documentoNew: "",
  });

  clearState = () => {
    $("div[name=groupNroCuenta]").css("display", "block");
    $("select[name=tipoDocNew]").removeAttr("disabled");
    $("select[name=entidadNew]").removeAttr("disabled");
    return {
      tipoEntidadNew: "",
      entidadNew: "",
      entidadList: [],
      nroCuentaNew: "",
      nombreApellidoNew: "",
      tipoDocNew: "",
      documentoNew: "",
      errors: {},
    }
  };

  // ################ SELECT ############## //
  listaTipoEntidad() {
    const listaTipoEntidad = this.state.tipoEntidadList.map((item) => (
      <option key={item} value={item}>
        {item}
      </option>
    ));

    listaTipoEntidad.unshift(
      <option key="-1" value="" disabled>
        -- Seleccione--
      </option>
    );

    return (
      <div className="form-group">
        <label className="input-label">Tipo Entidades *</label>
        <select
          name="tipoEntidad"
          value={this.state.tipoEntidadNew}
          className="form-control input-box"
          style={{ width: "100%" }}
          onChange={(val) => {
            this.changeTipoEntidad(val.target.value);
          }}>
          {listaTipoEntidad}
        </select>
      </div>
    );
  }

  changeTipoEntidad = (tipoEntidad) => {

    let newState = this.state;

    if (tipoEntidad === "TARJETA DIMO") {

      $("div[name=groupNroCuenta]").css("display", "none");
      $("select[name=tipoDocNew]").attr("disabled", true);
      $("select[name=entidadNew]").attr("disabled", true);

      newState = {
        ...newState,
        tipoDocNew: "3",
        entidadNew: "1600"
      }

    } else {

      $("div[name=groupNroCuenta]").css("display", "block");
      $("select[name=tipoDocNew]").removeAttr("disabled");
      $("select[name=entidadNew]").removeAttr("disabled");

      newState = {
        ...newState,
        tipoDocNew: "",
        entidadNew: undefined,
        nroCuentaNew: ""
      }

    }

    newState = {
      ...newState,
      tipoEntidadNew: tipoEntidad
    }

    this.setState(newState);
    this.getEntidades(tipoEntidad);

  };

  listaEntidad() {
    const listaEntidad = this.state.entidadList.map((item) => (
      <option key={item.name} value={item.code}>
        {item.name}
      </option>
    ));

    listaEntidad.unshift(
      <option key="-1" value="">
        -- Seleccione--
      </option>
    );

    return (
      <div className="form-group">
        <label className="input-label">Entidades *</label>
        <select name="entidadNew" value={this.state.entidadNew} className="form-control input-box" style={{ width: "100%" }}
          onChange={(val) => {
            this.setState({ entidadNew: val.target.value });
          }}>
          {listaEntidad}
        </select>
      </div>
    );
  }

  listaTipoDocumento() {
    const listaTipoDocumento = this.state.tipoDocList.map((item) => (
      <option key={item.id} value={item.id}>
        {item.descripcion}
      </option>
    ));
    listaTipoDocumento.unshift(
      <option key="-1" value="">
        -- Seleccione--
      </option>
    );
    return (
      <div className="form-group">
        <label className="input-label">Tipo de Documento *</label>
        <select name="tipoDocNew" value={this.state.tipoDocNew} className="form-control input-box"
          style={{ width: "100%" }}
          onChange={(val) => {
            this.setState({ tipoDocNew: val.target.value });
          }}>
          {listaTipoDocumento}
        </select>
      </div>
    );
  }


  // ################ SERVICES ############## //
  getTipoEntidad() {
    trackPromise(
      TransferXpressService.getTipoEntidades().then((response) => {
        var data = JSON.stringify(response.data);
        var jData = JSON.parse(data);
        if (jData.codigoRetorno === '0') {
          let lista = jData.datos.tipoEntidad.filter(e => e !== 'TODO');
          this.setState({ tipoEntidadList: lista });
        }
      })
    ).catch(function (error) {
      console.log(error);
    });
  }

  getEntidades(tipoEntidad) {
    trackPromise(
      TransferXpressService.getEntidades(tipoEntidad).then((response) => {
        var data = JSON.stringify(response.data);
        var jData = JSON.parse(data);
        if (jData.codigoRetorno === '0') {
          this.setState({ entidadList: jData.datos });
        }
      })
    ).catch(function (error) {
      console.log(error);
    });
  }

  getTiposDocumentos() {
    trackPromise(
      TransferInterbancaService.getTiposDocumentos().then((response) => {
        var data = JSON.stringify(response.data);
        var jData = JSON.parse(data);
        if (jData.codigo === 0) {
          let lista = jData.datos.filter(e => e.descripcion !== 'PAS');
          this.setState({ tipoDocList: lista });
        }
      })
    ).catch(function (error) {
      console.log(error);
    });
  }

  obtenerCodigoDestinatario() {
    let entidad = this.state.entidadList.filter(e => e.code === this.state.entidadNew);
    if (entidad[0].cabal === false) {
      return "1602";
    } else {
      return entidad[0].code;
    }
  }

  guardar() {
    console.log('entra a guardar');
    let destinatario = this.obtenerCodigoDestinatario();
    CuentaExternaService.addCuentaExterna(
      this.state.nombreApellidoNew,
      this.state.nroCuentaNew,
      this.state.tipoDocNew,
      this.state.documentoNew,
      this.state.entidadNew,
      "CABAL",
      destinatario
    )
      .then((response) => {
        var data = JSON.stringify(response.data);
        var jData = JSON.parse(data);
        if (jData.codigo === 0) {
          this.setState(this.clearState());
          this.modalCuenta.click();
          this.props.addCuentaCallback("OK");
        } else {
          Popup.queue(this.notifiPopup("Error", jData.mensaje));
          this.props.addCuentaCallback("FAIL");
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  // ################ VALIDACION DE FORMULARIO NATIVA ############## //
  validate = () => {
    const errors = {};
    // Validaciones
    if (!this.state.tipoEntidadNew) {
      errors.tipoEntidadNew = "Este campo es requerido";
    }
    if (!this.state.entidadNew) {
      errors.entidadNew = "Este campo es requerido";
    }
    if (!this.state.nroCuentaNew) {
      errors.nroCuentaNew = "Este campo es requerido";
    } else if (!/^[0-9]+$/.test(this.state.nroCuentaNew)) {
      errors.nroCuentaNew = "Favor ingrese un número válido, sin guión ni caracteres especiales";
    } else if (isNaN(Number(this.state.nroCuentaNew))) {
      errors.nroCuentaNew = "Sólo números para Número de Cuenta";
    }
    if (!this.state.nombreApellidoNew) {
      errors.nombreApellidoNew = "Este campo es requerido";
    }
    if (!this.state.tipoDocNew) {
      errors.tipoDocNew = "Este campo es requerido";
    }
    if (!this.state.documentoNew) {
      errors.documentoNew = "Este campo es requerido";
    } else if (this.state.tipoDocNew === "3" && isNaN(Number(this.state.documentoNew))) {
      errors.documentoNew = "Sólo números para Cédula de Identidad";
    }
    this.setState({ errors });
    return Object.keys(errors).length === 0;
  };

  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });

  render() {
    const { errors } = this.state;
    return (
      <form id="idFormAddCuenta"
        onSubmit={(e) => {
          e.preventDefault();
          if (this.validate()) {
            this.guardar();
          }
        }}>
        <div className="modal fade" id="modal-cuenta" data-backdrop="false" >
          <div className="modal-dialog  modal-dialog-centered  modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Datos de la Cuenta</h5>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-6">
                    {this.listaTipoEntidad()}
                    {errors.tipoEntidadNew && <span className="invalid-feedback d-block">{errors.tipoEntidadNew}</span>}
                  </div>
                  <div className="col-md-6">
                    {this.listaEntidad()}
                    {errors.entidadNew && <span className="invalid-feedback d-block">{errors.entidadNew}</span>}
                  </div>
                  <div className="col-12">
                    <div className="form-group" name="groupNroCuenta">
                      <label name="nroCuentaLabel" className="input-label">Nro. de Cuenta</label>
                      <input placeholder="Ingresar sin guiones (-) o barras (/)"
                        name="nroCuentaNew"
                        value={this.state.nroCuentaNew}
                        type="text"
                        maxLength={this.state.tipoEntidadNew === "COOPERATIVA" ? 16 : 10}
                        className={`input-box form-control${errors.nroCuentaNew ? ' is-invalid' : ''}`}
                        onChange={(val) => {
                          this.setState({ nroCuentaNew: val.target.value });
                        }} />
                      {errors.nroCuentaNew && <span className="invalid-feedback d-block">{errors.nroCuentaNew}</span>}
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-group">
                      <label className="input-label">Nombre y Apellido</label>
                      <input name="nombreApellidoNew" value={this.state.nombreApellidoNew} type="text"
                        className={`input-box form-control${errors.nombreApellidoNew ? ' is-invalid' : ''}`}
                        onChange={(val) => {
                          this.setState({
                            nombreApellidoNew: val.target.value.toUpperCase(),
                          });
                        }} />
                      {errors.nombreApellidoNew && <span className="invalid-feedback d-block">{errors.nombreApellidoNew}</span>}
                    </div>
                  </div>
                  <div className="col-12">
                    {this.listaTipoDocumento()}
                    {errors.tipoDocNew && <span className="invalid-feedback d-block">{errors.tipoDocNew}</span>}
                  </div>
                  <div className="col-12">
                    <div className="form-group">
                      <label className="input-label">Documento</label>
                      <input name="documentoNew" value={this.state.documentoNew} type="text"
                        className={`input-box form-control${errors.documentoNew ? ' is-invalid' : ''}`}
                        onChange={(val) => {
                          this.setState({ documentoNew: val.target.value });
                        }} />
                      {errors.documentoNew && <span className="invalid-feedback d-block">{errors.documentoNew}</span>}
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <div className="col-md-12">
                <div className="row">
                  <div className="col-md-6">
                  <button type="button" className="btn btn-cu-quintary" data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    this.setState(this.clearState());
                  }} >
                 <FontAwesomeIcon icon={faClose} /> Cerrar
                </button>
                  </div>
                  <div className="col-md-6">
                  <button type="submit" className="btn btn-cu-primary">
                 <FontAwesomeIcon icon={faSave} /> Guardar
                </button>
                  </div>
                </div>
                </div>
                
              </div>
            </div>
            {/* /.modal-content */}
          </div>
          {/* /.modal-dialog */}
          <a data-controls-modal="modal-cuenta"
            ref={(a) => (this.modalCuenta = a)}
            data-backdrop="false" href="#" hidden id="showModalCuenta" data-toggle="modal"
            data-target={"#modal-cuenta"}
          ></a>
        </div>
      </form>
    );
  }
}
